(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * 動画ヒーローの再生／一時停止（WCAG 2.2.2 Pause, Stop, Hide）。
   *
   * hero.liquid の video_tag は autoplay / loop / muted で controls を出さないため、
   * 停止手段をこのコンポーネントが担う。prefers-reduced-motion: reduce のときは
   * 接続時に停止させる（autoplay 属性はパーサが先に処理するので、CSS では止められない）。
   */
  class HeroVideoToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.wrapper = this.closest('.hero__media-wrapper');
      if (!this.button || !this.wrapper) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onClick = () => this.setPaused(!this.hasAttribute('data-paused'));
      this.onPreferenceChange = () => {
        if (this.reduceMotion.matches) this.setPaused(true);
      };
      this.onVideoState = () => this.syncLabel();

      this.button.addEventListener('click', this.onClick);
      this.reduceMotion.addEventListener('change', this.onPreferenceChange);
      this.videos.forEach((video) => {
        video.addEventListener('play', this.onVideoState);
        video.addEventListener('pause', this.onVideoState);
      });

      if (this.reduceMotion.matches) this.setPaused(true);
      else this.syncLabel();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.reduceMotion?.removeEventListener('change', this.onPreferenceChange);
      this.videos.forEach((video) => {
        video.removeEventListener('play', this.onVideoState);
        video.removeEventListener('pause', this.onVideoState);
      });
    }

    get videos() {
      return this.wrapper ? Array.from(this.wrapper.querySelectorAll('video')) : [];
    }

    setPaused(paused) {
      this.videos.forEach((video) => {
        if (paused) {
          video.pause();
          return;
        }
        // ミュートでないと再生がブロックされる
        video.muted = true;
        const played = video.play();
        if (played && typeof played.catch === 'function') played.catch(() => {});
      });
      this.syncLabel(paused);
    }

    /** 実際の再生状態からラベルと表示アイコンを合わせる */
    syncLabel(forcePaused) {
      const videos = this.videos;
      const paused = forcePaused === undefined ? videos.length > 0 && videos.every((v) => v.paused) : forcePaused;
      this.toggleAttribute('data-paused', paused);
      const { labelPause, labelPlay } = this.button.dataset;
      this.button.setAttribute('aria-label', paused ? labelPlay : labelPause);
    }
  }

  if (!customElements.get('hero-video-toggle')) {
    customElements.define('hero-video-toggle', HeroVideoToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setting-sheets-yokomo"] && !Shopify.designMode) return;
  try {
    
  /**
   * セッティングシート一覧の残りページの読み込みと絞り込み（#636）。
   *
   * 1ページ目（または開いたページ）はサーバー描画済み。残りのページを Section Rendering API で取り、
   * 同じ `data-group-key` の機種見出しにカードを追記してから、機種・機種内の順を並べ直す。
   * 絞り込みは各 `[data-sheet-item]` の `data-search-text` を検索窓の語と語の頭から照合して（仕様はファイル先頭のコメント「絞り込み」）、
   * hidden を切り替えるだけ。カテゴリ（`data-category`）・機種（`data-model`）は機種見出し単位で AND をとる。
   * `?q=` `?category=` `?model=` があれば初期値にし、変えたら URL に書き戻す。
   */
  class SettingSheetsYokomoFilter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-filter-input]');
      this.groupsRoot = this.querySelector('[data-sheet-groups]');
      this.loading = this.querySelector('[data-filter-loading]');
      this.empty = this.querySelector('[data-filter-empty]');
      this.pagination = this.querySelector('[data-sheet-pagination]');
      if (!this.input || !this.groupsRoot) return;

      this.groups = new Map();
      this.groupsRoot.querySelectorAll('[data-sheet-group]').forEach((group) => {
        this.groups.set(group.dataset.groupKey, group);
      });
      this.sheetKeys = new Set(
        Array.from(this.groupsRoot.querySelectorAll('[data-sheet-item]'), (item) => item.dataset.sheetKey)
      );

      this.categorySelect = this.querySelector('[data-filter-category]');
      this.modelSelect = this.querySelector('[data-filter-model]');
      this.kindSelect = this.querySelector('[data-filter-kind]');

      this.onInput = () => this.apply(true);
      this.onSubmit = (event) => {
        event.preventDefault();
        this.apply(true);
      };
      this.onCategoryChange = () => {
        // 選んでいる機種が別のカテゴリなら外す（まだ読み込んでいない機種は判断できないので残す）
        const group = this.findModelGroup(this.selectedModel);
        if (group && this.category && group.dataset.category !== this.category) this.selectedModel = '';
        this.renderModelOptions();
        this.apply(true);
      };
      this.onModelChange = () => {
        this.selectedModel = this.modelSelect.value;
        this.apply(true);
      };
      this.onKindChange = () => {
        this.selectedKind = this.kindSelect.value;
        this.apply(true);
      };

      this.input.addEventListener('input', this.onInput);
      this.input.form?.addEventListener('submit', this.onSubmit);
      this.categorySelect?.addEventListener('change', this.onCategoryChange);
      this.modelSelect?.addEventListener('change', this.onModelChange);
      this.kindSelect?.addEventListener('change', this.onKindChange);

      const params = new URL(window.location.href).searchParams;
      this.input.value = params.get('q') || '';
      if (this.categorySelect) {
        this.categorySelect.value = params.get('category') || '';
        // 選択肢に無い値だと何も選ばれていない表示になるので「すべて」に戻す
        if (this.categorySelect.selectedIndex === -1) this.categorySelect.value = '';
      }
      // 機種は2ページ目以降にあるかもしれないので、選択肢とは別に持つ
      this.selectedModel = params.get('model') || '';
      // 種別も同じく2ページ目以降にしか無いことがある
      this.selectedKind = params.get('kind') || '';

      this.renderModelOptions();
      this.renderKindOptions();
      this.apply(false);
      this.loadRemainingPages();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.input?.form?.removeEventListener('submit', this.onSubmit);
      this.categorySelect?.removeEventListener('change', this.onCategoryChange);
      this.modelSelect?.removeEventListener('change', this.onModelChange);
      this.kindSelect?.removeEventListener('change', this.onKindChange);
    }

    get category() {
      return this.categorySelect?.value || '';
    }

    /** 大文字小文字・空白・ハイフン・`_` の違いを無視する（全角は NFKC で半角に寄せる） */
    static normalize(value) {
      return SettingSheetsYokomoFilter.indexWords(value).text;
    }

    /**
     * `normalize` した文字列と、元の文字列で語の頭だった位置を返す。
     * 語の頭: 先頭・英数字以外の直後・英字から数字に変わる位置（BD10 の 1）。非 ASCII 文字はどれも語の頭とする
     */
    static indexWords(value) {
      let text = '';
      const starts = new Set();
      let previous = '';
      for (const char of value.normalize('NFKC').toLowerCase()) {
        if (!/[\s\-‐-―−_]/.test(char)) {
          if (
            !/[a-z0-9]/.test(previous) ||
            !/[\x00-\x7f]/.test(char) ||
            (/[a-z]/.test(previous) && /[0-9]/.test(char))
          ) {
            starts.add(text.length);
          }
          text += char;
        }
        previous = char;
      }
      return { text, starts };
    }

    /** `query`（`normalize` 済み）が語の頭から始まる位置に含まれていれば当たり */
    static matchesWords(words, query) {
      for (let at = words.text.indexOf(query); at !== -1; at = words.text.indexOf(query, at + 1)) {
        if (words.starts.has(at)) return true;
      }
      return false;
    }

    static compare(a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    }

    /** 辿るページ数の上限（250件 × 40 = 1万件）。URL が循環したときに止めるための保険 */
    static MAX_PAGES = 40;

    /**
     * 開いたページの前後を、サーバーが描画した `data-next-url` / `data-previous-url` を辿って端まで取る。
     * ⚠️ ページ送りのパラメータ名は `page` ではなく `page_xxxxxxxx` の形で、ストア側が決める。
     *    JS でパラメータ名を組み立てず、必ず `paginate.next.url` / `paginate.previous.url` を使う
     */
    async loadRemainingPages() {
      const sectionId = this.dataset.sectionId;
      const { nextUrl, previousUrl } = this.dataset;
      if (!sectionId || (!nextUrl && !previousUrl)) return;

      this.isLoading = true;
      this.updateStatus();

      const visited = new Set();
      const completed = await Promise.all([
        this.followPages(sectionId, nextUrl, 'nextUrl', visited),
        this.followPages(sectionId, previousUrl, 'previousUrl', visited),
      ]);

      // 1ページでも取れなかったときはページ送りを残す（そのページへは遷移で行ける）
      if (this.pagination && completed.every(Boolean)) {
        this.pagination.hidden = true;
      }

      this.isLoading = false;
      this.apply(false);
    }

    /**
     * `startUrl` から、取ってきたページの `data-*`（`direction`）が無くなるまで1ページずつ取る。
     * 取れた分はその都度追記して絞り込み直す。端まで取れたら true
     */
    async followPages(sectionId, startUrl, direction, visited) {
      let pageUrl = startUrl;

      for (let count = 0; pageUrl && count < SettingSheetsYokomoFilter.MAX_PAGES; count += 1) {
        const url = new URL(pageUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        if (visited.has(url.href)) return true;
        visited.add(url.href);

        let fetched;
        try {
          fetched = await this.fetchPage(url);
        } catch (error) {
          console.error(error);
          return false;
        }

        this.merge(fetched);
        this.arrange();
        this.apply(false);

        pageUrl = fetched.querySelector('setting-sheets-yokomo-filter')?.dataset[direction];
      }

      return !pageUrl;
    }

    async fetchPage(url) {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`setting-sheets-yokomo: ${url} returned ${response.status}`);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    /**
     * 取ってきたページの機種ごとのカードを、同じ機種の見出しに追記する（無ければ見出しごと足す）。
     * 同じ document（`data-sheet-key` = handle）が既にあれば足さない
     */
    merge(fetched) {
      fetched.querySelectorAll('[data-sheet-group]').forEach((group) => {
        const items = Array.from(group.querySelectorAll('[data-sheet-item]')).filter((item) => {
          const sheetKey = item.dataset.sheetKey;
          if (this.sheetKeys.has(sheetKey)) {
            item.remove();
            return false;
          }
          this.sheetKeys.add(sheetKey);
          return true;
        });
        if (items.length === 0) return;

        const key = group.dataset.groupKey;
        const existing = this.groups.get(key);

        if (existing) {
          existing.querySelector('[data-sheet-list]')?.append(...items);
        } else {
          const adopted = document.adoptNode(group);
          this.groupsRoot.append(adopted);
          this.groups.set(key, adopted);
        }
      });
    }

    /** 機種キーの昇順、機種内は `data-item-order`（日付の反転）の昇順に並べ直す */
    arrange() {
      const keys = Array.from(this.groups.keys()).sort(SettingSheetsYokomoFilter.compare);

      keys.forEach((key) => {
        const group = this.groups.get(key);
        const list = group.querySelector('[data-sheet-list]');
        if (list) {
          const items = Array.from(list.querySelectorAll('[data-sheet-item]'));
          items.sort((a, b) => SettingSheetsYokomoFilter.compare(a.dataset.itemOrder, b.dataset.itemOrder));
          list.append(...items);
        }
        this.groupsRoot.append(group);
      });

      this.renderModelOptions();
      this.renderKindOptions();
    }

    /** `model`（機種名）が一致する機種見出し。大文字小文字・空白・ハイフンの違いは無視する */
    findModelGroup(model) {
      if (!model) return null;
      const target = SettingSheetsYokomoFilter.normalize(model);
      for (const group of this.groups.values()) {
        const name = group.dataset.model || '';
        if (name && SettingSheetsYokomoFilter.normalize(name) === target) return group;
      }
      return null;
    }

    /**
     * 機種の選択肢を、並べ終えた機種見出しの順（= `model_sort` 順）で作り直す。
     * カテゴリを選んでいればそのカテゴリの機種だけ。選んでいる機種がまだ読み込まれていなければ、
     * その名前の選択肢を末尾に足して選択中の表示を保つ
     */
    renderModelOptions() {
      if (!this.modelSelect) return;

      const names = [];
      this.groupsRoot.querySelectorAll('[data-sheet-group]').forEach((group) => {
        const name = group.dataset.model || '';
        if (!name || names.includes(name)) return;
        if (this.category && group.dataset.category !== this.category) return;
        names.push(name);
      });

      const selectedGroup = this.findModelGroup(this.selectedModel);
      const selectedName = selectedGroup ? selectedGroup.dataset.model : this.selectedModel;
      if (selectedName && !names.includes(selectedName)) names.push(selectedName);

      // 同じ選択肢なら作り直さない（開いているプルダウンが閉じないように）
      const signature = names.join('\n');
      if (signature !== this.modelSignature) {
        this.modelSignature = signature;
        const allOption = this.modelSelect.options[0];
        this.modelSelect.replaceChildren(
          allOption,
          ...names.map((name) => new Option(name, name))
        );
      }
      this.modelSelect.value = selectedName;
    }

    /** `kind`（種別）が一致する資料の `data-kind`。大文字小文字・空白・ハイフンの違いは無視する */
    findKind(kind) {
      if (!kind) return '';
      const target = SettingSheetsYokomoFilter.normalize(kind);
      for (const item of this.groupsRoot.querySelectorAll('[data-sheet-item][data-kind]')) {
        const name = item.dataset.kind;
        if (name && SettingSheetsYokomoFilter.normalize(name) === target) return name;
      }
      return '';
    }

    /**
     * 種別の選択肢（`[data-filter-kind]`）を、読み込み済みの資料の `data-kind` から作り直す。
     * 読み込みの順で並びが揺れないよう五十音順。カテゴリ・機種では狭めない（資料の多くは機種が無い）。
     * 選んでいる種別がまだ読み込まれていなければ、その名前の選択肢を末尾に足して選択中の表示を保つ
     */
    renderKindOptions() {
      if (!this.kindSelect) return;

      const names = new Set();
      const labels = new Map();
      this.groupsRoot.querySelectorAll('[data-sheet-item][data-kind]').forEach((item) => {
        if (!item.dataset.kind) return;
        names.add(item.dataset.kind);
        labels.set(item.dataset.kind, item.dataset.kindLabel || item.dataset.kind);
      });
      // 並びは表示ラベル順（言語ごとに五十音／アルファベット）。値は kind のまま持つ
      const sorted = Array.from(names).sort((a, b) => labels.get(a).localeCompare(labels.get(b), document.documentElement.lang || 'ja'));

      const selectedName = this.findKind(this.selectedKind) || this.selectedKind;
      if (selectedName && !names.has(selectedName)) sorted.push(selectedName);

      // 同じ選択肢なら作り直さない（開いているプルダウンが閉じないように）
      const signature = sorted.join('\n');
      if (signature !== this.kindSignature) {
        this.kindSignature = signature;
        const allOption = this.kindSelect.options[0];
        this.kindSelect.replaceChildren(
          allOption,
          ...sorted.map((name) => new Option(labels.get(name) || name, name))
        );
      }
      this.kindSelect.value = selectedName;
    }

    apply(updateUrl) {
      const query = SettingSheetsYokomoFilter.normalize(this.input.value);
      const category = this.category;
      const model = SettingSheetsYokomoFilter.normalize(this.selectedModel);
      const kind = SettingSheetsYokomoFilter.normalize(this.selectedKind);
      this.visibleCount = 0;

      this.groups.forEach((group) => {
        let groupVisible = 0;

        // カテゴリ・機種は見出し単位で決まる。機種が未読み込みのあいだは、どの見出しも当たらない
        group.normalizedModel ??= SettingSheetsYokomoFilter.normalize(group.dataset.model || '');
        const groupMatched =
          (!category || group.dataset.category === category) && (!model || group.normalizedModel === model);
        if (!groupMatched) {
          group.hidden = true;
          return;
        }

        // 文字検索・種別は資料単位で決まる。種別が未読み込みのあいだは、どの資料も当たらない
        group.querySelectorAll('[data-sheet-item]').forEach((item) => {
          item.searchWords ??= SettingSheetsYokomoFilter.indexWords(item.dataset.searchText || '');
          item.normalizedKind ??= SettingSheetsYokomoFilter.normalize(item.dataset.kind || '');
          const matched =
            (query === '' || SettingSheetsYokomoFilter.matchesWords(item.searchWords, query)) &&
            (!kind || item.normalizedKind === kind);
          item.hidden = !matched;
          if (matched) groupVisible += 1;
        });

        group.hidden = groupVisible === 0;
        this.visibleCount += groupVisible;
      });

      this.updateStatus();
      if (updateUrl) this.syncUrl();
    }

    updateStatus() {
      if (this.loading) this.loading.hidden = !this.isLoading;
      if (this.empty) this.empty.hidden = Boolean(this.isLoading) || this.visibleCount > 0;
    }

    /** 文字検索・カテゴリ・機種・種別を `?q=` `?category=` `?model=` `?kind=` に反映する（空なら消す） */
    syncUrl() {
      const url = new URL(window.location.href);
      const state = {
        q: this.input.value.trim(),
        category: this.category,
        model: this.selectedModel,
        kind: this.selectedKind,
      };
      Object.entries(state).forEach(([name, value]) => {
        if (value) {
          url.searchParams.set(name, value);
        } else {
          url.searchParams.delete(name);
        }
      });
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  }

  if (!customElements.get('setting-sheets-yokomo-filter')) {
    customElements.define('setting-sheets-yokomo-filter', SettingSheetsYokomoFilter);
  }

  } catch(e) { console.error(e); }
})();
})();
